import React, { useContext } from "react";
import { Add } from "@material-ui/icons";
import { DataGrid } from "@mui/x-data-grid";
import { Card, CardHeader, Col, Container, Row } from "reactstrap";
import { IconButton, Tooltip } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import LoaderContext from "../../context/LoaderContext/LoaderContext";
import { TostMessage } from "../../components ByteCard/utils";
import DataNotFound from "../../DataNoteFound/DataNotFound";
import { MuiTabelStyle, headerStyle } from "../../utils/MuiTabelStyle";
import { MOMENT_SETTING, PLAN_MASTER, Style } from "../../constant";
import { TabelAnimation } from "../../Spinner";
import OrgPlanContext from "../../context/OrgPlanContext/OrgPlanContext";
import { Details_OrgPlan_List } from "../../api/OrgPlanApi/OrgPlanApi";

const OrgPlanItem = (props) => {
  const { sorting, handleDelete } = props;
  const { setLoaderShow } = useContext(LoaderContext);
  const {
    formValue,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setAddModel,
    setFormData,
    setIsEdit,
    setId,
  } = useContext(OrgPlanContext);

  const EditHandle = async (planId) => {
    try {
      setLoaderShow(true);
      setId(planId);
      const { data } = await Details_OrgPlan_List(planId);
      if (data.status === 200) {
        let payload = data.payload.data;
        const itemThemeAll = payload?.pageItemThemeMapDetails?.map((ele) => {
          return {
            value: ele.itemId,
            label: ele.itemMasterDetail?.label,
          };
        });
        setFormData({
          templateName: payload?.templateName || "",
          code: payload?.code || "",
          itemIds: itemThemeAll || [],
          isSystem: +payload?.isSystem === 0 ? false : true,
        });
        setIsEdit(true);
        setLoaderShow(false);
        setAddModel(true);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 200,
      field: "planId",
      headerName: "Plan Id",
      renderCell: (params) => (params.row.planId ? params.row.planId : "-"),
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: "planName",
      headerName: "Plan Name",
      renderCell: (params) => (params.row.planName ? params.row.planName : "-"),
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: "hwId",
      headerName: "hwId",
      renderCell: (params) => (params.row.hwId ? params.row.hwId : "-"),
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: "amount",
      headerName: "Amount",
      renderCell: (params) => (params.row.amount ? params.row.amount : "-"),
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: "expiredAt",
      headerName: "Expired Date",
      renderCell: (params) =>
        params.row.expiredAt
          ? moment.utc(params.row.expiredAt).format(MOMENT_SETTING.FORMATE)
          : "-",
    },
    {
      flex: 0.01,
      minWidth: 100,
      field: "edit",
      headerName: "Edit",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Tooltip title="Edit">
          <IconButton
            aria-label="edit"
            style={{ color: "green" }}
            onClick={() => EditHandle(params.row.planId)}
          >
            <ModeEditIcon />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      flex: 0.01,
      minWidth: 100,
      field: "delete",
      headerName: "Delete",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Tooltip title="Delete">
          <IconButton
            aria-label="delete"
            style={{ color: "red" }}
            onClick={() => handleDelete(params.row.planId)}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const AddProducts = () => {
    setAddModel(true);
  };
  return (
    <>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <h3 style={headerStyle}>{PLAN_MASTER.THEME_NAME}</h3>

                <div
                  aria-label="add"
                  onClick={() => AddProducts()}
                  className="btn btn-primary"
                  style={Style}
                >
                  <Add />
                </div>
              </CardHeader>
              {TabelAnimation === true ? (
                <TabelAnimation />
              ) : formValue.length ? (
                <DataGrid
                  autoHeight
                  sx={MuiTabelStyle}
                  pagination
                  rows={formValue}
                  getRowId={(row) => row.planId}
                  columns={defaultColumns}
                  rowsPerPageOptions={[7, 10, 25, 50]}
                  rowCount={record}
                  pageSize={pageSize}
                  page={page - 1}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                  paginationMode="server"
                  disableSelectionOnClick
                  checkboxSelection={false}
                  sortingMode="server"
                  onSortModelChange={sorting}
                />
              ) : (
                <DataNotFound />
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OrgPlanItem;
